import actions from "./actions";

const {FETCH_SLIDE, FETCH_SLIDES, RESET_SLIDE} = actions;
const initState = {
    slides: {
        page: 0,
         perPage: 35,
        data: [],
        total: 0
    },
    slide: {_id: null}
};

const SlideReducer = (state = initState, action) => {
    const {type, data} = action;
    switch (type) {
        case FETCH_SLIDES:
            return {
                ...state,
                slides: data
            }
        case RESET_SLIDE:
            return {
                ...state,
                slide: initState.slide,
            };
        case FETCH_SLIDE:
            return {
                ...state,
                slide: data,
            };
        default:
            return state;
    }
}

export default SlideReducer;
